import React from "react";

import {
  RideTextField,
  RideRadioButtonGroup,
  RideRadioButton,
} from "@rimac-seguros/ride-system-components";
import { DateTime } from "luxon";

import "./styles.scss";
import helpers from '@/utils/helpers'

export const FormBasicInformation = ({
  register,
  prefixControl,
  prefixError,
  loadingSave,
}) => {
  const isVE = helpers.validateVidaEndosable();

  return (
    <div className="grid grid-cols-2 gap-y-ride-gl-spacing-2xlarge gap-x-ride-gl-spacing-xlarge lg:gap-x-ride-gl-spacing-2xlarge lg:gap-y-ride-gl-spacing-3xlarge">
      <RideTextField
        {...register(`${prefixControl}.names`, {
          required: isVE ? "Ingresa los nombres" : true,
          minLength: 2,
        })}
        label="Nombres"
        aria-required
        autoComplete="off"
        size="large"
        className="col-span-full"
        disabled={loadingSave}
        error={!!prefixError?.names}
        errorMessage={prefixError?.names?.message || "Este campo es obligatorio"}
      />
      <RideTextField
        {...register(`${prefixControl}.lastName`, {
          required: isVE ? "Ingresa un apellido paterno" : "Este campo es obligatorio",
        })}
        label="Apellido paterno"
        aria-required
        autoComplete="off"
        size="large"
        disabled={loadingSave}
        error={!!prefixError?.lastName}
        errorMessage={prefixError?.lastName?.message}
        className="col-span-1 lg:col-span-full"
      />
      <RideTextField
        {...register(`${prefixControl}.surName`, {
          required: isVE ? "Ingresa un apellido materno" : false,
        })}
        label="Apellido materno"
        aria-required
        autoComplete="off"
        size="large"
        disabled={loadingSave}
        error={!!prefixError?.surName}
        errorMessage={prefixError?.surName?.message}
        className="col-span-1 lg:col-span-full"
      />
      <RideTextField
        {...register(`${prefixControl}.birthdate`, {
          required: isVE ? "Ingresa una fecha de nacimiento" : true,
          validate: {
            isValidDate: (value) => {
              const { isValid } = DateTime.fromFormat(value, "dd/MM/yyyy");
              return isValid || "Formato inválido";
            },
            limitDate: (value) => {
              const date = DateTime.fromFormat(value, "dd/MM/yyyy");
              const now = DateTime.now();
              const year = date.year;

              return (date <= now && year >= 1900) || "Fecha fuera de rango";
            },
          },
        })}
        label="Fecha de nacimiento"
        aria-required
        autoComplete="off"
        size="large"
        placeholder="Día / Mes / Año"
        maxLength={10}
        disabled={loadingSave}
        error={!!prefixError?.birthdate}
        errorMessage={
          prefixError?.birthdate?.message || "Este campo es obligatorio"
        }
        customMask
        mask="00/00/0000"
        className="col-span-full lg:col-span-1"
      />
      <RideRadioButtonGroup
        label="Género"
        orientation="horizontal"
        disabled={loadingSave}
        error={!!prefixError?.gender}
        errorMessage={prefixError?.gender?.message || "Este campo es obligatorio"}
        className="modal-ab_gender col-span-full lg:col-span-1"
      >
        <RideRadioButton
          name="gender"
          text="Femenino"
          value="F"
          {...register(`${prefixControl}.gender`, { required: isVE ? "Elige un género" : true })}
        />
        <RideRadioButton
          name="gender"
          text="Masculino"
           value="M"
          {...register(`${prefixControl}.gender`, { required: isVE ? "Elige un género" : true })}
        />
      </RideRadioButtonGroup>
    </div>
  );
};
